<template>
	<div class="app-mains">
		<transition name="fade-transform" mode="out-in">
		  <keep-alive >
		    <router-view :key="key" />
		  </keep-alive>
		</transition>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				
			}
		},
		computed: {
		  // cachedViews() {
		  //   return this.$store.state.tagsView.cachedViews
		  // },
		  key() {
		    return this.$route.path
		  }
		},
		methods:{
			
		}
	}
</script>

<style lang="scss">
	.app-mains{
		background-color: #FFFFFF;
		min-height: calc(100vh - 74px);
		position: relative;
		overflow: hidden;
		// margin-left: 162px;
		// margin-top: 74px;
		padding-top: 74px;
		width: 790px;
		margin: 0 auto;
	}
</style>
